<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="查询名称">
                  <el-input  v-model="queryForm.authName"></el-input>
              </el-form-item>
              <el-form-item label="实名类型">
                  <el-select size="small" clearable v-model="queryForm.authType" placeholder="请选择" style="width: 200px">
                      <el-option v-for="item in AuthTypeList" :key="item.key" :label="item.value" :value="item.key"> </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getMppUserAuthList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
<!--        <el-button-->
<!--          type="primary"-->
<!--          size="small"-->
<!--          icon="el-icon-plus"-->
<!--          @click="addMppUserAuth"-->
<!--        >新建</el-button>-->
<!--        <el-button-->
<!--          type="warning"-->
<!--          plain-->
<!--          size="small"-->
<!--          icon="el-icon-edit"-->
<!--          :disabled="multipleSelection.length != 1"-->
<!--          @click="editMppUserAuth(null)"-->
<!--        >修改</el-button>-->
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteMppUserAuth(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
<!--        <span-->
<!--          title="下载模板"-->
<!--          class="icon-box"-->
<!--          @click="importTemplate"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDown />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          class="icon-box"-->
<!--          title="导入数据"-->
<!--          @click="isImport"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowExportUp24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          title="导出数据"-->
<!--          class="icon-box"-->
<!--          @click="exportMppUserAuthList"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDownload24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
        <span
          class="icon-box"
          @click="refreshMppUserAuthList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="mppUserAuthList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="authName"
        label="姓名或公司名称"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="authId"
        label="身份证码或者营业执照号"
        width="240"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="authType"
        label="实名类型"
        width="180"
      >
        <template slot-scope="scope">
            <div>{{computeAuthType(scope.row.authType)}}</div>
        </template>

      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="birthDay"
        label="生日或注册时间"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="authTime"
        label="实名认证通过时间"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="authStatus"
        label="审核状态"
        width="180"
      >
        <template slot-scope="scope">
            <div v-if="scope.row.authStatus == 0">未提交</div>
            <div v-else-if="scope.row.authStatus == 1">审核中</div>
            <div v-else-if="scope.row.authStatus == 2">审核成功</div>
            <div v-else-if="scope.row.authStatus == 3">审核失败</div>
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="auditAuth(scop.row)" v-if="scop.row.authStatus == 1">
               <el-button type="primary" size="small">审核</el-button>
            </div>
            <div @click="checkMppUserAuth(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editMppUserAuth(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteMppUserAuth(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="mppUserAuthStates[mppUserAuthState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="mppUserAuth"
          ref="mppUserAuthForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="姓名或公司名称"
            prop="authName"
          >
            <el-input
              size="small"
              v-model="mppUserAuth.authName"
              :disabled="mppUserAuthState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="身份证码或者营业执照号"
            prop="authId"
          >
            <el-input
              size="small"
              v-model="mppUserAuth.authId"
              :disabled="mppUserAuthState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="实名类型 1个人 2企业"
            prop="authType"
          >
            <el-input
              size="small"
              v-model="mppUserAuth.authType"
              :disabled="mppUserAuthState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="生日或注册时间"
            prop="birthDay"
          >
            <el-input
              size="small"
              v-model="mppUserAuth.birthDay"
              :disabled="mppUserAuthState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="名实认真通过的时间"
            prop="authTime"
          >
            <el-input
              size="small"
              v-model="mppUserAuth.authTime"
              :disabled="mppUserAuthState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="审核状态"
            prop="authStatus"
          >
            <el-input
              size="small"
              v-model="mppUserAuth.authStatus"
              :disabled="mppUserAuthState == 'check'"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="mppUserAuthState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
      <!--审核功能-->
      <el-dialog title="实名认证审核" ref="auditAuth" :visible.sync="auditAuthDialogVisible" width="30%" :before-close="auditAuthCloseRetreat">
          <el-form ref="auditAuth" :rules="auditAuthRules" size="small" :model="auditAuthForm" label-width="100px">
              <el-form-item label="是否同意：" prop="resource">
                  <el-radio-group v-model="auditAuthForm.resource">
                      <el-radio label="true">同意</el-radio>
                      <el-radio label="false">拒绝</el-radio>
                  </el-radio-group>
              </el-form-item>
              <el-form-item label="拒绝原因：" v-if="auditAuthForm.resource == 'false'" prop="desc">
                  <el-input style="width: 100%" type="textarea" v-model="auditAuthForm.desc"></el-input>
              </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
              <el-button @click="auditAuthCloseRetreat">取 消</el-button>
              <el-button type="primary" @click="auditAuthSuccess('retreatForm')">确 定</el-button>
          </span>
      </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import fa from 'element-ui/src/locale/lang/fa';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetMppUserAuthList();
                    this.getMppUserAuthList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetMppUserAuthList();
                    this.getMppUserAuthList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                AuthTypeList: [], // 实名类型枚举
                auditAuthDialogVisible: false,
                auditAuthForm:{
                    resource:'',
                    desc:'',
                    id:''
                },

                queryForm:{
                     authName: '', //姓名或公司名称
                     authType: '', //实名类型 1个人 2企业
                },
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                mppUserAuthState: 'add',
                mppUserAuthStates: {
                    add: '新建实名',
                    check: '查看实名',
                    edit: '修改实名'
                },

                multipleSelection: [],
                mppUserAuthList: [],
                mppUserAuth: {
                    authName: '', //姓名或公司名称
                    authId: '', //身份证码或者营业执照号
                    authType: '', //实名类型 1个人 2企业
                    birthDay: '', //生日或注册时间
                    authTime: '', //名实认真通过的时间
                    authStatus: '', //审核状态
                    userId: '', //用户
                },
                btnLoading: false,

                rules: {
                    authName: [{ required: true, message: '姓名或公司名称不能为空', trigger: 'blur' }],
                    authId: [{ required: true, message: '身份证码或者营业执照号不能为空', trigger: 'blur' }],
                    authType: [{ required: true, message: '实名类型 1个人 2企业不能为空', trigger: 'blur' }],
                    birthDay: [{ required: true, message: '生日或注册时间不能为空', trigger: 'blur' }],
                    authTime: [{ required: true, message: '名实认真通过的时间不能为空', trigger: 'blur' }],
                    authStatus: [{ required: true, message: '审核状态不能为空', trigger: 'blur' }],

                },

                auditAuthRules:{
                    resource: [{ required: true, message: '审核操作不能为空', trigger: 'blur' }],
                    desc: [{ required: true, message: '拒绝理由不能为空', trigger: 'blur' }],
                }
            };
        },
        created() {
            this.getMppUserAuthList();
            this.getAuthTypeEnmu();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            resetMppUserAuthList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.mppUserAuthList = [];
            },
            resetDialog() {
                this.mppUserAuthState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      authName: '', //姓名或公司名称
                      authType: '', //实名类型 1个人 2企业
                };
                this.getMppUserAuthList();
            },
            closeDialog() {
                this.mppUserAuth = {
                      authName: '', //姓名或公司名称
                      authId: '', //身份证码或者营业执照号
                      authType: '', //实名类型 1个人 2企业
                      birthDay: '', //生日或注册时间
                      authTime: '', //名实认真通过的时间
                      authStatus: '', //审核状态
                };
                this.showDialog = false;
            },
            submitForm() {
                if (this.mppUserAuthState == 'add') {
                    this.$refs.mppUserAuthForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/mpp/userauth/add`,{ ...this.mppUserAuth }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetMppUserAuthList();
                                    this.resetDialog();
                                    this.getMppUserAuthList();
                                }
                            });
                        }
                    });
                } else if (this.mppUserAuthState == 'edit') {
                    this.$refs.mppUserAuthForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/mpp/userauth/edit`,{ ...this.mppUserAuth }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetMppUserAuthList();
                                    this.resetDialog();
                                    this.getMppUserAuthList();
                                }
                            });
                        }
                    });
                }
            },
            addMppUserAuth() {
                this.showDialog = true;
                this.mppUserAuthState = 'add';
            },
            checkMppUserAuth(mppUserAuthId) {
                console.log(mppUserAuthId);
                this.currentMppUserAuthId = mppUserAuthId;

                this.getMppUserAuthById();
                this.showDialog = true;
                this.mppUserAuthState = 'check';
            },
            editMppUserAuth(mppUserAuthId) {
                console.log('mppUserAuth', mppUserAuthId);
                if (mppUserAuthId) {
                    this.currentMppUserAuthId = mppUserAuthId;
                    this.getMppUserAuthById();
                } else {
                    this.mppUserAuth = { ...this.mppUserAuth, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.mppUserAuthState = 'edit';
            },
            deleteMppUserAuth(mppUserAuthId) {
                let ids = '';
                if (mppUserAuthId) {
                    ids = mppUserAuthId;
                } else {
                    ids = this.multipleSelection.map((mppUserAuth) => mppUserAuth.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/mpp/userauth/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetMppUserAuthList();
                                this.getMppUserAuthList();
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshMppUserAuthList() {
                this.resetMppUserAuthList();
                this.getMppUserAuthList();
            },
            getMppUserAuthList(query = {}) {
                this.loading = true;
                get(`/mpp/userauth/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.mppUserAuthList = res.page.list;
                        this.totalNum = res.page.total;
                    }
                });
            },
            getMppUserAuthById() {
                get(`/mpp/userauth/get`,{ id: this.currentMppUserAuthId }).then((res) =>{
                    if(res.success){
                      this.mppUserAuth = { ...this.mppUserAuth, ...res.mppUserAuth };
                    }
                });
            },
            /**
             * 导出信息
             */
            exportMppUserAuthList() {
                //this.btnLoading = true;
                exprotExcel(`/mpp/userauth/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/mpp/userauth/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/mpp/userauth/importData`,formData);
              this.refreshMppUserAuthList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getMppUserAuthList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getMppUserAuthList();
            },

            // 获取审核状态枚举


            // 获取实名类型枚举
            getAuthTypeEnmu(){
                get('/mpp/utils/getEnum',{ enumType: 'realname_auth_type'}).then((res)=>{
                    if(res.success){
                        this.AuthTypeList = res.enumList
                    }
                })
            },

            // 计算实名类型
            computeAuthType(type){
                for (let i = 0; i < this.AuthTypeList.length; i++) {
                    if(this.AuthTypeList[i].key == type){
                        return this.AuthTypeList[i].value
                    }
                }
            },

            // 审核按钮
            auditAuth(item){
                this.auditAuthDialogVisible = true
                this.auditAuthForm = {
                    resource:'',
                    desc:'',
                    id: item.id
                }
            },

            // 审核取消
            auditAuthCloseRetreat(){
                this.auditAuthDialogVisible = false
                this.auditAuthForm = {
                    resource:'',
                    desc:'',
                    id:''
                }
            },

            // 审核确定
            auditAuthSuccess(){
                this.$refs.auditAuth.validate((valid) => {
                    if (valid) {
                        let sratus
                        if(this.auditAuthForm.resource == 'true'){
                            sratus = 2
                        }else if(this.auditAuthForm.resource == 'false'){
                            sratus = 3
                        }

                        get(`/mpp/userauth/auditAuth`,{
                            id:this.auditAuthForm.id,
                            status:sratus,
                            refuseReason: this.auditAuthForm.desc
                        }).then((res) => {
                            if(res.success){
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.auditAuthDialogVisible = false
                            }
                        });
                    }
                });
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>
